import React from "react";

type Props = {
	children: React.ReactNode;
};

export const QuestionPlanOptionConnectionRoot = ({ children }: Props) => {
	return <>{children}</>;
};

QuestionPlanOptionConnectionRoot.displayName = "QuestionPlanOptionConnectionRoot";
